import { useEffect, useState } from 'react';
import { fetchScreenPlacement } from '../api/connectionRegistryApi';

// Which screens have been moved to Supporting Tools Live. One copy is kept for the
// whole app so the nav, the screens pages and Settings agree, and Settings can
// publish a move without anything having to remount.
let liveKeys = null; // null until the first load completes
let inflight = null;
const listeners = new Set();

const publish = (keys) => {
  liveKeys = keys;
  listeners.forEach((fn) => fn(keys));
};

export function refreshPlacement() {
  if (!inflight) {
    inflight = fetchScreenPlacement()
      .then((res) => publish(Array.isArray(res?.live) ? res.live : []))
      // A failed read leaves every screen where it started (Supporting Tools)
      // rather than hiding them all.
      .catch((e) => {
        console.error('fetchScreenPlacement', e);
        publish([]);
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export const setPlacement = (keys) => publish(Array.isArray(keys) ? keys : []);

/** { live: Set of screen keys in Supporting Tools Live, loading } */
export function useScreenPlacement() {
  const [keys, setKeys] = useState(liveKeys);

  useEffect(() => {
    listeners.add(setKeys);
    if (liveKeys === null) refreshPlacement();
    else setKeys(liveKeys);
    return () => { listeners.delete(setKeys); };
  }, []);

  return { live: new Set(keys || []), loading: keys === null };
}
